module.exports = __webpack_public_path__ + "img/img63.442147de.svg";